// extracted by mini-css-extract-plugin
export default {"cardLayer":"ratingCardLayout_cardLayer__EAXys","ratingCardContent":"ratingCardLayout_ratingCardContent__InAk4"};